<div class="header">
    <div class="top">
        @if (backUrl()) {
        <a [routerLink]="backUrl()">
            <h3>{{backText()}} /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{title()}}</h2>
            </div>
        </a>
        } @else {
        <h1>{{title()}}</h1>
        @if (subtitle()) {
        <h3>{{subtitle()}}</h3>
        }
        }
    </div>
</div>